import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { createProfileForNewUser } from '../lib/profileService';

/**
 * Strona obsługująca redirect po kliknięciu w link potwierdzający email.
 * Supabase przekierowuje tutaj z tokenami w URL (hash lub query).
 */
export const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const hash = window.location.hash?.slice(1) || '';
      const search = window.location.search?.slice(1) || '';
      const hashParams = new URLSearchParams(hash);
      const searchParams = new URLSearchParams(search);

      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');
      const tokenHash = searchParams.get('token_hash') || hashParams.get('token_hash');
      const type = searchParams.get('type') || hashParams.get('type') || 'signup';

      // Opcja 1: tokeny w hash (domyślny redirect Supabase)
      if (accessToken && refreshToken) {
        const { data, error: err } = await supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
        if (!cancelled) {
          if (err) setError(err.message);
          else {
            if (data?.user?.id) {
              sessionStorage.setItem('justRegisteredUserId', data.user.id);
              const displayName = data.user.user_metadata?.full_name?.trim() || null;
              console.log('AuthCallback: Tworzę profil dla:', data.user.id);
              await createProfileForNewUser(data.user.id, displayName);
            }
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/', { replace: true });
          }
        }
        return;
      }

      // Opcja 2: token_hash (np. custom flow)
      if (tokenHash) {
        const { data, error: err } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: type === 'signup' ? 'signup' : 'email'
        });
        if (!cancelled) {
          if (err) setError(err.message);
          else {
            if (data?.user?.id) {
              sessionStorage.setItem('justRegisteredUserId', data.user.id);
              const displayName = data.user.user_metadata?.full_name?.trim() || null;
              console.log('AuthCallback (token_hash): Tworzę profil dla:', data.user.id);
              await createProfileForNewUser(data.user.id, displayName);
            }
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/', { replace: true });
          }
        }
        return;
      }

      // Brak tokenów – może sesja już istnieje
      const { data: { session } } = await supabase.auth.getSession();
      if (!cancelled && session) {
        navigate('/', { replace: true });
        return;
      }

      if (!cancelled) {
        setError('Nie znaleziono danych uwierzytelniających. Link mógł wygasnąć.');
      }
    };

    run();
    return () => { cancelled = true; };
  }, [navigate]);

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'linear-gradient(135deg, #e8ecff 0%, #f3e8ff 50%, #ede9fe 100%)'
      }}>
        <p style={{ color: '#dc2626', marginBottom: 16, textAlign: 'center' }}>{error}</p>
        <a href="/" style={{ color: '#6B7FFF', fontWeight: 600 }}>Wróć do logowania</a>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'linear-gradient(135deg, #e8ecff 0%, #f3e8ff 50%, #ede9fe 100%)'
    }}>
      <p style={{ color: '#64748b' }}>Potwierdzanie konta...</p>
      <p style={{ color: '#94a3b8', fontSize: 14, marginTop: 8 }}>Za chwilę zostaniesz przekierowany</p>
    </div>
  );
};
